import { environment } from '@app-environments/environment';
import * as moment from 'moment';
import { BatchModel } from './batch';
import { TeacherModel } from './teacher';
export class CourseModel {
  id: any;
  batchId: any;
  subjects: any = ['CHEM', 'MATH', 'BIOL'];
  title: string = '';
  description: string = '';
  note: string = '';
  teachers: Array<TeacherModel> = [];
  subjectTeachers: any = [];
  schedule: any = {};
  duration: any;
  grade: number = 0;
  sessions: any;
  curriculam: any;
  exams: Array<string> = [];
  batch: Array<string> = [];
  expertise: Array<string> = [];
  faq: Array<string> = [];
  global: boolean = false;
  status: string = '';
  subscription: string = '';
  isFeatured: boolean = false;
  featureDescription: string = '';
  isCourseSelected: boolean = true;
  createdAt: any;
  updatedAt: any;
  language: string = 'English';
  studentId: any;
  totalAssignment = 0;
  totalAttended = 0;
  totalAttendedDuration = 0;
  totalAttentdedAssignment = 0;
  totalCoursePercentage = 0;
  totalSession = 0;
  totalDuration = 0;
  totalRegisterStudent = 0;
  enrollInfo: any;
  completionPercentage: any;
  totalHoursTaughtByTeacherText: any;
  courseType: any;
  batchPicture: any;
  recommended: boolean;
  isRecordedCourse:any;
  constructor(public obj: any) {
    // this.getSubject(obj.subjects);
    this.id = obj && obj.id ? obj.id : '';
    this.subjects = this.getSubject(obj.subjects);
    this.title = obj?.name || '';
    this.description = obj?.description || '';
    this.note = obj?.note || '';
    this.teachers =
      obj.teachers && obj.teachers.length > 0
        ? obj.teachers.map((val: any) => new TeacherModel(val))
        : [];
    this.schedule = {
      startDate: moment.unix(obj.startDate).format(),
      startTime: moment.unix(obj.startDate).format(),
      endTime: moment.unix(obj.endDate).format(),
      endDate: moment.unix(obj.endDate).format(),
      serverTime: obj.serverTime
        ? moment.unix(obj.serverTime)
        : obj.utcTime
        ? moment.unix(obj.utcTime)
        : moment().utc().unix(),
    };
    this.sessions = obj?.sessions;
    this.curriculam = obj?.curriculum || null;
    this.duration = obj?.duration || 0;
    // this.grade = obj?.grade || 0;
    this.grade = this.getStudentGrade(obj?.grade);
    this.exams = obj?.exams || [];
    this.batchId =
      obj?.batches && obj?.batches?.length > 0 && obj?.batches[0]?.id
        ? obj?.batches[0].id
        : obj?.batches?.[0] || '';
    this.batch =
      obj?.batches && obj?.batches?.length > 0
        ? obj.batches.map((val: any) => new BatchModel(val))
        : [];
    this.expertise = obj?.coursePointer || [];
    this.faq = obj?.faq || [];
    this.global = obj?.global || false;
    this.status = obj?.status || 'active';
    this.subscription = obj?.subscription || 'FREE';
    this.featureDescription =
      obj && obj.otherDescription ? obj.otherDescription : '';
    this.isCourseSelected = obj?.isCourseSelected;
    this.createdAt = obj?.createdAt;
    this.updatedAt = obj?.updatedAt;
    this.language = obj?.language;
    this.studentId = obj?.studentId;
    this.totalAssignment = obj?.totalNumberOfAssignments;
    this.totalAttended = obj?.totalAttended;
    this.totalAttendedDuration = obj.totalAttendedDuration;
    this.totalAttentdedAssignment = obj.totalAssignmentCompleted;
    this.totalCoursePercentage = obj?.totalCoursePercentage
      ? parseFloat(parseFloat(obj.totalCoursePercentage).toFixed(2))
      : 0;
    this.totalSession = obj.totalSession;
    this.totalDuration = obj?.totalDuration;
    this.enrollInfo = obj?.enrollInfo || '';
    this.totalRegisterStudent = obj?.totalRegisterStudent || 0;
    this.subjectTeachers = this.getSubjectWiseTeacherList(obj);
    this.completionPercentage = obj?.completionPercentage || 0;
    this.totalHoursTaughtByTeacherText =
      obj?.totalHoursTaughtByTeacherText || 0;
    this.courseType = obj.type;
    this.batchPicture = obj.batchPicture;
    this.recommended = obj?.recommended;
    this.isRecordedCourse= obj?.isRecordedCourse?  obj?.isRecordedCourse:false;
  }

  getSubject(sub: any) {
    let subject;
    subject = new Set(sub
      .sort()
      .map((v: any) =>
        v == 'MATH'|| v =='MATH/APPLIED MATH'
          ? 'Maths'
          : v == 'CHEM'
          ? 'Chemistry'
          : v == 'BIOL' || v == 'BOTA' || v == 'ZOOL' || v == 'BOT'
          ? 'Biology'
          : v == 'PHYS' || v == 'PHY'
          ? 'Physics'
          : v.charAt(0).toUpperCase()+ v.slice(1)
      ));
    return subject;
  }

  getSubjectWiseTeacherList(_obj: any = null) {
    if (
      _obj &&
      _obj != undefined &&
      _obj?.subjects?.length > 0 &&
      _obj?.teachers?.length > 0
    ) {
      let _subTeacherArr: any = [];

      for (const subject of _obj?.subjects) {
        let _subTeacher = _obj?.teachers?.filter((x: any) =>
          x?.subjects
            .map((x: any) => x?.toLowerCase())
            .includes(subject?.toLowerCase())
        );
        if (_subTeacher?.length > 0) {
          _subTeacherArr.push({
            subject: this.getSubjectName(subject?.toLowerCase()),
            teachers: _subTeacher?.map((val: any) => new TeacherModel(val)),
          });
        }
      }
      return _subTeacherArr;
    } else {
      return [];
    }
  }

  getSubjectName(sub: string) {
    sub = sub?.toLowerCase();
    switch (sub) {
      case 'math':
      case 'maths':
        return 'Maths';
        break;
      case 'chem':
        return 'Chemistry';
        break;
      case 'biol':
        return 'Biology';
        break;
      case 'phys':
      case 'phy':
        return 'Physics';
        break;
      case 'zool':
        return 'Zoology';
        break;
      default:
        return '';
        break;
    }
  }

  getStudentGrade(grade) {
    let userGrade = JSON.parse(localStorage.getItem('mobile_and_name'))
    let selectedGrade = grade?.toString()?.split(',')?.filter((g) => g == userGrade?.grade);
    return selectedGrade[0];
  }
}
